import styled from 'styled-components';

export const MemberCommentBlock = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 20px;
`;
